module.exports = __webpack_public_path__ + "static/media/ic_expand_view.cc5e1e9e.svg";